import { CaretRight as CaretRightIcon } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

export type Props = {
  header: React.ReactNode;
  children: React.ReactNode;
};

const Root = styled.div`
  display: block;
`;

const LeftIconContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 12px;
  }
`;

const StyledCaretIcon = styled(CaretRightIcon)<{ direction: 'down' | 'right' }>`
  transition: transform 500ms cubic-bezier(0.16, 1, 0.3, 1);
  transform: ${({ direction, theme }) => {
    if (direction === 'down') {
      return 'rotate(90deg)';
    }
    return theme?.cbDirection === 'rtl' ? 'rotate(180deg)' : 'none';
  }};
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  padding-inline-start: 16px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const ChildContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CollapsibleContainer: React.FC<Props> = ({ children, header }) => {
  const [isExpanded, setIsExpanded] = React.useState(true);

  return (
    <Root>
      <div
        onClick={() => {
          setIsExpanded(current => !current);
        }}
      >
        <HeaderContainer>
          <LeftIconContainer>
            <StyledCaretIcon direction={isExpanded ? 'down' : 'right'} />
          </LeftIconContainer>
          {header}
        </HeaderContainer>
      </div>
      {isExpanded && <ChildContainer>{children}</ChildContainer>}
    </Root>
  );
};

export default React.memo(CollapsibleContainer);
